import React from 'react';
import SearchTextBox from './search-textbox';
import SearchResults from './search-results';
import Top from './top';

const SupportSearchPage = () => {

    return (
        <div className="w-full mb-24 overflow-hidden">
            <div className="w-full mt-0 lg:mt-8">
                <Top />
                <SearchTextBox/>
            </div>

            <SearchResults/>
        </div>
    )
};

export default SupportSearchPage;